import { Network, DataSet } from 'vis-network/standalone';

const ROLE_COLORS = {
  admin:        '#e74c3c',
  distributor:  '#2ecc71',
  instructor:   '#3498db',
  practitioner: '#f39c12'
};

const INACTIVE_COLOR = '#cccccc';

function initNetworkGraph() {
  let container = document.getElementById('user-network');
  if (!container || !window.networkGraphData) return;

  let data = window.networkGraphData;

  let nodes = new DataSet(data.nodes.map(function(n) {
    let color = n.active ? (ROLE_COLORS[n.role] || '#999') : INACTIVE_COLOR;
    return {
      id: n.id,
      label: n.label,
      color: {
        background: color,
        border: color,
        highlight: { background: color, border: '#333' }
      },
      font: {
        color: n.active ? '#333' : '#999',
        size: 14
      },
      shape: 'dot',
      size: n.role === 'admin' ? 20 : (n.role === 'distributor' || n.role === 'instructor' ? 16 : 12),
      borderWidth: n.active ? 2 : 1
    };
  }));

  let edgeColors = {
    instructor:             { color: '#3498db', highlight: '#2980b9' },
    distributor:            { color: '#2ecc71', highlight: '#27ae60' },
    distributor_instructor: { color: '#f39c12', highlight: '#e67e22' }
  };

  let edges = new DataSet(data.edges.map(function(e, i) {
    let ec = edgeColors[e.type] || edgeColors.distributor;
    return {
      id: i,
      from: e.from,
      to: e.to,
      arrows: 'to',
      color: ec,
      width: 2,
      smooth: { type: 'cubicBezier', roundness: 0.4 }
    };
  }));

  let options = {
    physics: {
      solver: 'forceAtlas2Based',
      forceAtlas2Based: {
        gravitationalConstant: -40,
        centralGravity: 0.005,
        springLength: 150,
        springConstant: 0.02
      },
      stabilization: { iterations: 200 }
    },
    interaction: {
      hover: true,
      tooltipDelay: 200,
      zoomView: true,
      dragView: true
    },
    layout: {
      improvedLayout: true
    }
  };

  new Network(container, { nodes: nodes, edges: edges }, options);
}

document.addEventListener('turbolinks:load', initNetworkGraph);
